<ng-container>
<div class="w-100 text-center">
    <pagination-controls id="page-interventions" style="text-align: center;" (pageChange)="pageChange($event)" previousLabel="Précédent" nextLabel="Suivant"></pagination-controls>
    <p>{{suiviCount}} interventions</p>
</div>
<table class="table table-striped">
    <tbody>
        <tr>
            <th>Date</th>
            <th>Motif</th>
            <th>Intervenant</th>
        </tr>
        <ng-container *ngIf="interventions && !loading">
            <tr *ngFor="let intervention of interventions.suivis | paginate : {itemsPerPage: 20, currentPage: p, totalItems: suiviCount, id: 'page-interventions'}" [routerLink]="['/call', intervention.id_sav_suivi]">
                <td>{{ intervention.date_debut }}</td>

                <ng-container *ngFor ="let act of intervention.actions">
                    <td>{{ act.nom_action }}</td>
                </ng-container>

                <ng-container *ngFor="let inter of intervention.intervenants">
                    <td>{{ inter.intervenant }}</td>
                </ng-container>

            </tr>
        </ng-container>
        <ng-container *ngIf="loading">
            <app-gmao-spinner></app-gmao-spinner>
        </ng-container>
    </tbody>

</table>
</ng-container>